import Axios from 'axios';
import env from '../env';

const publicHttpClient = Axios.create({
  baseURL: `${env.SERVER_ENDPOINT}/`,
});

publicHttpClient.interceptors.request.use(
  async function (config) {
    if (config.method !== 'OPTIONS') {
      // config.headers.Authorization = `ApiKey ${env.API_KEY}`;
      config.headers.ContentType = 'application/json';
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default publicHttpClient;
